import AdminNewSidebar from "components/admin/AdminNewSidebar";
import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import { Table, Button, Form, Row, Col, Image } from "react-bootstrap";
import { toast } from "react-toastify";
import apis from "../../services";
import { useDispatch } from "react-redux";
import { setAdmin } from "redux/slices/adminSlice";
import useNavigate from "hooks/Navigate";
import { FaPlus } from "react-icons/fa";
export default function CreatePopup() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [popupTypes, setPopupTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [links, setLinks] = useState([""]); // Initialize with 1 empty link
  const handleLinkChange = (index, value) => {
    const updatedLinks = [...links];
    updatedLinks[index] = value;
    setLinks(updatedLinks);
  };
  
  // Handle adding a new link
  const handleAddLink = () => {
    if (links.length < 3) {
      setLinks([...links, ""]);
    } else {
      toast.error("You can only add up to 3 links.");
    }
  };
  const [formData, setFormData] = useState({
    titleEn: "",
    titleSp: "",
    subtitleen: "",
    subtitleSp: "",
    contentEn: "",
    contentSp: "",
    buttonNameEn: "",
    buttonNameSp: "",

  });

  const fetchPopupTypes = async () => {
    try {
      const response = await apis.getPopupTypes();
      if (response?.data?.status) {
        setPopupTypes(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch popup types");
    }
  };

  useEffect(() => {
    fetchPopupTypes();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onChangeHandler = (e) => {
    const { id, value } = e.currentTarget;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const createPopup = async (popupData) => {
    try {
      const payload = new FormData();
      payload.append("title_en", popupData.titleEn);
      payload.append("title_sp", popupData.titleSp);
      payload.append("sub_title_en", popupData.subtitleen);
      payload.append("sub_title_sp", popupData.subtitleSp);
      payload.append("body_en", popupData.contentEn);
      payload.append("body_sp", popupData.contentSp);
      payload.append("button_en", popupData.buttonNameEn);
      payload.append("button_sp", popupData.buttonNameSp);
      payload.append("type", selectedType);
      links.forEach((link) => {
        if (link.trim()) {
          payload.append("link[]", link.trim());
        }
      });
  
      if (selectedImage) {
        payload.append("media", selectedImage);
      }

      const response = await apis.createPopup(payload);
      if (response?.data?.status) {
        toast.success("Popup created successfully");
        navigate("/admin/popup-management");

        setFormData({
          titleEn: "",
          titleSp: "",
          subtitleen: "",
          subtitleSp: "",
          contentEn: "",
          contentSp: "",
          buttonNameEn: "",
          buttonNameSp: "",
          link:""
        });
        setLinks([""]); // Reset links
        setSelectedImage(null);
        setImagePreview(null);
      } else {
        toast.error("Failed to create popup");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error creating popup");
    } finally {
      setLoader(false);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const { titleEn, titleSp, subtitleen,subtitleSp, contentEn, contentSp, buttonNameEn, buttonNameSp,link } = formData;

    if (!titleEn || !titleSp || !contentEn || !contentSp || !buttonNameEn || !buttonNameSp || !selectedType) {
      return toast.error("All fields are required in both English and Spanish.");
    }

    setLoader(true);
    createPopup(formData);
  };

  return (
    <Box className="dashboard-main">
      <AdminNewSidebar />
      <div className="dashboard-section-main">
        <Box component="main" sx={{ flexGrow: 1, height: "100vh", overflow: "auto" }} className="custom-scroll">
          <Header />
          {loader ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }} className="mainContainerComp" style={{ paddingBottom: "1px" }}>
              <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                <h2 style={{
                  color: "#000",
                  fontFamily: "'Poppins', sans-serif",
                  fontSize: "36px",
                  letterSpacing: "2px",
                  textAlign: "center",
                  margin: 0,
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                }}>
                  {t("buttons.create-popup")}
                </h2>
              </div>

              <div className="p-4 mb-5" style={{ border: "1px solid #e0201c", borderRadius: "30px" }}>
                <h4 className="mb-4">{t("buttons.create-new-popup")}</h4>
                <Form onSubmit={submitHandler}>
                  <Row>
                    {/* Titles */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Title (English)</Form.Label>
                        <Form.Control
                          type="text"
                          id="titleEn"
                          placeholder="Enter English title"
                          value={formData.titleEn}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Title (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="titleSp"
                          placeholder="Ingrese título en español"
                          value={formData.titleSp}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subtitle (English)</Form.Label>
                        <Form.Control
                          type="text"
                          id="subtitleen"
                          placeholder="Ingrese título en español"
                          value={formData.subtitleen}
                          onChange={onChangeHandler}
                          
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Subtitle (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="subtitleSp"
                          placeholder="Ingrese título en español"
                          value={formData.subtitleSp}
                          onChange={onChangeHandler}
                          
                        />
                      </Form.Group>
                    </Col>

                    {/* Content */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Content (English)</Form.Label>
                        <Form.Control
                          as="textarea"
                          id="contentEn"
                          placeholder="Enter content in English"
                          value={formData.contentEn}
                          onChange={onChangeHandler}
                          rows={5}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Content (Spanish)</Form.Label>
                        <Form.Control
                          as="textarea"
                          id="contentSp"
                          placeholder="Ingrese contenido en español"
                          value={formData.contentSp}
                          onChange={onChangeHandler}
                          rows={5}
                          required
                        />
                      </Form.Group>
                    </Col>

                    {/* Button Name */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Button Name (English)</Form.Label>
                        <Form.Control
                          type="text"
                          id="buttonNameEn"
                          placeholder="Enter button name in English"
                          value={formData.buttonNameEn}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Button Name (Spanish)</Form.Label>
                        <Form.Control
                          type="text"
                          id="buttonNameSp"
                          placeholder="Ingrese nombre del botón en español"
                          value={formData.buttonNameSp}
                          onChange={onChangeHandler}
                          required
                        />
                      </Form.Group>
                    </Col>

                    {/* Type */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("fields.type")}</Form.Label>
                        <Form.Select
                          id="type"
                          value={selectedType}
                          onChange={(e) => setSelectedType(e.target.value)}
                          required
                        >
                          <option value="">Select Popup Type</option>
                          {popupTypes.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
{/* link */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>{t("fields.link")}</Form.Label>

    {links.map((link, index) => (
      <Form.Control
        key={index}
        type="text"
        placeholder={`Enter link ${index + 1}`}
        value={link}
        onChange={(e) => handleLinkChange(index, e.target.value)}
        className="mb-2"
        pattern="^(https?:\/\/|www\.)[^\s]+$"
      />
    ))}

    {links.length < 3 && (
   <Button
   type="button"
   onClick={handleAddLink}
   size="sm"
   style={{
     marginTop: "10px",
     border: "1px solid rgb(224, 32, 28)",
     borderRadius: "30px",
     color: "rgb(224, 32, 28)", // text color to match border
     backgroundColor: "transparent", // keep background white
   }}
 >
   <FaPlus /> Add Link
 </Button>
 
    )}

    <Form.Text className="text-danger d-block mt-2">
      Please enter a valid link starting with http://, https://, or www.
    </Form.Text>
  </Form.Group>
</Col>


                    {/* Image */}
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>{t("fields.image-select")}</Form.Label>
                        <div
                          style={{
                            border: "2px dashed #e0201c",
                            borderRadius: "12px",
                            padding: "1.5rem",
                            textAlign: "center",
                            backgroundColor: "#fff9f9",
                          }}
                        >
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            disabled={loader}
                            style={{ display: "none" }}
                            id="create-image-upload"
                          />
                          <label htmlFor="create-image-upload" style={{ cursor: "pointer" }}>
                            <p>{imagePreview ? "Change Image" : "Click to Upload"}</p>
                          </label>
                        </div>

                        {imagePreview && (
                          <div className="text-center mt-3">
                            <img src={imagePreview} alt="Preview" style={{ width: "200px", borderRadius: "10px" }} />
                            <div className="mt-2">
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                  setImagePreview(null);
                                  setSelectedImage(null);
                                }}
                              >
                                Remove Image
                              </Button>
                            </div>
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={12} className="text-center">
                      <Button
                        variant="outline-danger"
                        type="submit"
                        disabled={loader}
                        style={{ width: "200px", marginTop: "20px" }}
                      >
                        {loader ? t("buttons.submitting") : t("buttons.submit")}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Container>
          )}
        </Box>
      </div>
    </Box>
  );
}
